import { APPLY_FDR_URL } from '../../../common/constants'

export const resolveDebtData = {
  title: 'End Your Debt',
  description: 'Find out how our program could help.',
  options: [
    'One low monthly program deposit',
    'Settlements for less than owed',
    'Debt could be resolved in 24-48 months',
  ],
  buttonTitle: 'Get Your Free Evaluation',
  buttonUrl: APPLY_FDR_URL(),
}
